<header>
  <a class="navbar-brand" [routerLink]=''>
    <img *ngIf="!showDefaultLogo" class="logo" [src]="logo" (error)="changeSourceGetDefault($event)" />
    <img *ngIf="showDefaultLogo" class="logo" src="../../../../assets/img/eagle-act.png" />
  </a>
  <h2 class="navbar-title"><span translate>General.Portail.Client</span> - <span translate>General.Portail.Bienvenue</span></h2>
</header>


